import { ILLGenericKeys } from './index';
import { ILLProductBase } from './ll-product-base.model';

export class ILLPart extends ILLProductBase {
  quantityValue: string;
  quantityUnit: ILLGenericKeys;
  productType: string;
  topLevelXMLNodeName: string;
}
